import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MainMenuComponent} from './main-menu/main-menu.component';
import {BasicInformationComponent} from './basic-information/basic-information.component';
import {OffersComponent} from './offers/offers.component';
import {DetailsComponent} from './details/details.component';
import {CustomButtonModule} from '../../Elements/custom-button/custom-button.module';
import {MainNavBarModule} from '../../Elements/main-nav-bar/main-nav-bar.module';
import {FormListGeneratorModule} from '../../Elements/form-list-generator/form-list-generator.module';
import {FormModule} from '../../Elements/form/form.module';
import {ConfirmComponent} from './confirm/confirm.component';
import {RouterModule, Routes} from '@angular/router';
import {RoleGuard} from '../../services/guards/role-guard.service';
import {DetailsDivModule} from '../../Elements/details-div/details-div.module';
import {FinanceInvoiceDivModule} from '../../Elements/finance-invoice-div/finance-invoice-div.module';
import {FileUploadDivModule} from '../../Elements/file-upload-div/file-upload-div.module';
import {VisitTypeDialogComponent} from '../../Dialogs/visit-type-dialog/visit-type-dialog.component';
import {ReservationDialogComponent} from '../../Dialogs/reservation-dialog/reservation-dialog.component';
import {TableModule} from '../../Elements/table/table.module';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';

const router: Routes = [
  {
    path: 'PET',
    children: [
      {
        path: '',
        component: MainMenuComponent
      },
      {
        path: 'main-menu',
        component: MainMenuComponent
      },
      {
        path: 'basic-information',
        component: BasicInformationComponent
      },
      {
        path: 'offers',
        component: OffersComponent
      },
      {
        path: 'confirm',
        component: ConfirmComponent
      },
      {
        path: 'details',
        component: DetailsComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      }
    ]
  }
];

@NgModule({
  declarations: [MainMenuComponent, BasicInformationComponent, OffersComponent, DetailsComponent, ConfirmComponent,
    VisitTypeDialogComponent, ReservationDialogComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(router),
    CustomButtonModule,
    MainNavBarModule,
    FormListGeneratorModule,
    FormModule,
    DetailsDivModule,
    FinanceInvoiceDivModule,
    FileUploadDivModule,
    TableModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class PetApplicationModule {
}
